/*
 * Ryan O'Dowd
 * 2019-05-28
 * © Copyright 2019 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({colors}) => {
  return {
    container: {
      backgroundColor: colors.primaryExtraDark,
      width: '100%',
    },
    footerInner: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 8,
      textDecoration: 'none',
      color: 'inherit',
    },
    text: {
      fontSize: 18,
      color: colors.white,
    },
    footerImage: {
      width: 24,
      height: 24,
      marginRight: 8,
      cursor: 'pointer',
    },
  };
};

export default getStyles;
